import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../../functions/translator.js';
import { FilterActions } from '../../../constants/constants.js';

class ZonesDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            defaultValue: [],
        }
    }

    handleZonesChange = (event) => {
        this.props.filterChange(FilterActions.ZONES, event.target.value)
    };

    handleClose = (event) => {
        this.props.filterChange(FilterActions.ZONES, this.state.defaultValue);
        this.props.closeCallback(event);
    }

    handleSelected = (zonesSelected) => {
        if (zonesSelected.length === 0) {
            return _('Todo')
        } else {
            let zoneNames = []
            for (const zoneId of zonesSelected) {
                let zoneData = this.props.zonesData[zoneId.toString()]
                zoneNames.push(zoneData.attributes.name)
            }
            return zoneNames.join(', ')
        }
    }

    render() {
        const options = []

        for (const [key, value] of Object.entries(this.props.zonesData)) {
            options.push(
                <MenuItem value={value.id} key={key}>
                    <Checkbox color="primary" checked={this.props.zoneIds.includes(value.id)}/>
                    {value.attributes.name}
                </MenuItem>
            )
        }

        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Ciclos') }
                    <CloseIcon className='float-right cursor-pointer' data-type='zones' onClick={this.handleClose}/>
                </p>
                <Select
                value={this.props.zoneIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.handleSelected}
                onChange={this.handleZonesChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {options}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        zoneIds   : state.filters.zoneIds,
        zonesData : state.projectData.zones
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ZonesDropdown);